module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-picklist"
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item[_vm.valueKey],
      attrs: {
        "label": item[_vm.nameKey],
        "value": item[_vm.valueKey]
      }
    }, [_vm._v(_vm._s(item[_vm.nameKey]))])
  }), 1), _vm._v(" "), _c('rt-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-dropdown"
    },
    slot: "suffix"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c75391"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/picklist/index.vue
// module id = 1450
// module chunks = 116